<template>
  <form class="form-template" @submit.prevent="submit">
    <!-- Form Template -->
    <template v-for="(field, key) in formFields">
      <data-driven-transition :key="`${_uid}-${field.name}`" :isNext="isNext">
        <field-group :field-id="key" :key="`${_uid}-${field.name}`">
          <div class="field-area">
            <field-label :class="$route.name" :for="`${_uid}-${field.name}`">{{ key + 1 }}. {{ field.label }}</field-label>
            <Component
              v-model="formData[field.name]"
              :is="field.component"
              v-bind="{ ...field.options.attrs }"
              :id="`${_uid}-${field.name}`"
              :name="`${field.name}`"
              :type="field.type"
              @input="updateField({ key: field.name, value: formData[field.name] })"
              v-validate="field.validation"
              :data-vv-as="field.label"
              :options="!!field.options.choices ? field.options.choices : false"
            />
            <footer
              v-if="window.width < 770">
              <button
                type="button"
                v-if="formState.activeField !== 0"
                :class="$route.name"
                @click="back"
                v-html="'&#8592;'"
              ></button>
              <button 
                @click="next"
                class="navigator"
                :class="`status-${ !formState.isValid ? 'warning' : 'ok' }`"
                v-html="!formState.isValid ? '&#63;' : '&#8594;' ">Continue</button>
            
            </footer>
          </div>
          <field-error>{{ errors.first(field.name) }}</field-error>
        </field-group>
      </data-driven-transition>
    </template>

    <!-- Next and Back Nav -->
    <!-- v-colorswatch:bg="formState.activeField" -->
    <form-nav 
      v-if="window.width >= 770"
      @back="back" @next="next" />

    <!-- Form Results -->
    <!-- <form-result /> -->
  </form>
</template>

<script>
import FieldGroup from "./FieldGroup.vue";
import FieldError from "./FieldError.vue";
import FieldLabel from "./FieldLabel.vue";

import FormNav from "./FormNav.vue";
// import FormResult from "./FormResult.vue";

import formMixin from "../../mixins/formMixin";
import { mapMutations } from "vuex";
import DataDrivenTransition from "../transitions/DataDrivenTransition.vue";

export default {
  name: "form-template",
  mixins: [formMixin],
  props: ["formFields"],
  data() {
    return {
      window: {
        width: 0,
        height: 0
      }
    }
  },
  created() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  },
  components: {
    FieldGroup,
    FieldError,
    FieldLabel,
    FormNav,
    // FormResult,
    DataDrivenTransition
  },
  provide() {
    return {
      formState: this.formState
    };
  },
  computed: {
    isNext() {
      return this.formState.isNext;
    }
  },
  methods: {
    ...mapMutations({
      updateField: "lead/updateField"
    }),
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    sendForm() {
      this.axios
        .post("https://admin.ryoma.eu/api/contacts", this.$store.state.lead.formData)
        .then(() => {
          // handle success
          this.$router.push({ name: "thank-you" });
        })
        .catch(err => {
          this.$router.push({ name: "error", params: { errType: err } });
        })
        .finally(() => {
          // always executed
          // console.log(response);
        });
    }
  }
};
</script>

<style lang="scss">
@import "../../styles/_mixins.scss";

.form-template {
  // box-shadow: -5px 10px 1px rgba(0,0,0,0.1);
  // padding: 0 3vmin 3vmin;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.field-area {
  position: relative;

  .navigator {
    position: absolute;
    color: map-get($colors--grays, '8');
    font-size: 1.5rem;
    bottom: 0;
    right: 0;
    width: 75px;
    height: 50px;
    border-radius: 0;
    padding: 0;

    &.status-ok {
      background: map-get($colors--status, 'ok');
      color: whitesmoke;
    }
    &.status-warning {
      background: map-get($colors--status, 'warning');
    }
  };
}
</style>